<template>
    <div id="contenedor-principal" class="container-fluid">
        <div id="encanezados-vista" class="padding-div-low">
            <h1>CREACIÓN DE REPORTES PARA CÉDULAS ENVIADAS AL JUZGADO</h1>
        </div>
        <div id="secciones-vista" class="row col-12">
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                <div class="area">
                    <h5>Selecciona los parámetros del reporte</h5>
                    <hr />
                    <div class="form-group">
                        <h6>Juzgado</h6> 
                        <C001Area class="p-0 m-0"
                            v-on:valorParaElPadre="evtCambioTipoArea" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="catalogoJuzgado.idInput" 
                            :parametros="catalogoJuzgado.parametros" 
                            :valorDefinido="catalogoJuzgado.valorDefinido" 
                            :key="'KJuzgado-VRCAJ' + catalogoJuzgado.contRender"></C001Area>
                    </div>
                    <div v-if="this.campoRequeridoEsValido(catalogoJuzgado.valorDefinido)" class="form-group">
                        <div class="form-group" style="margin-top:3em;">
                            <div style="display: flex; align-items: center;">
                                <h6 style="margin-right: 0.5em;">Rango de fechas: </h6>
                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <label class="btn btn-secondary" @click="rangoDeFechas.activo = true, rangoDeFechas.inicio = moment().subtract(1, 'days').format('YYYY-MM-DD'), rangoDeFechas.fin = moment().format('YYYY-MM-DD')">
                                    <input type="radio" name="options" id="radioVisualizarMapaSi" autocomplete="off" checked>Si
                                    </label>
                                    <label class="btn btn-secondary active" @click="rangoDeFechas.activo = false, rangoDeFechas.inicio = moment().format('YYYY-MM-DD'), rangoDeFechas.fin = moment().format('YYYY-MM-DD')">
                                    <input type="radio" name="options" id="radioVisualizarMapaNo" autocomplete="off">No
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div v-if="!rangoDeFechas.activo" class="form-group">
                            <h6 class="mt-4" for="fechaFinal">Fecha de envió a juzgado</h6>
                            <input type="date" id="fechaFinal" v-model="fechaDeEnvio" class="form-control" />
                        </div>
                        <div v-if="rangoDeFechas.activo">
                            <div class="form-group">
                                <h6 class="mt-4" for="fechaFinal">Fecha de inicio</h6>
                                <input type="date" id="fechaFinal" v-model="rangoDeFechas.inicio" class="form-control" />
                            </div>
                            <div class="form-group">
                                <h6 class="mt-4" for="fechaFinal">Fecha de fin</h6>
                                <input type="date" id="fechaFinal" v-model="rangoDeFechas.fin" class="form-control" />
                            </div>
                            <div class="d-flex justify-content-end mt-4">
                                <button @click="iniciarProcesoCreacionReportePorRangoDeFechas" type="button" class="btn btn-primary responsive-width"><i class="fas fa-file"></i>&nbsp;&nbsp;Crear Reporte</button>
                            </div>
                            <!-- <div v-if="this.visualizarReporte" class="d-flex justify-content-end mt-4">
                                <button type="button" class="btn btn-primary responsive-width"><i class="fas fa-file"></i>&nbsp;&nbsp;Descargar Reporte en Excel</button>
                            </div> -->
                        </div>
                        <div v-if="!rangoDeFechas.activo" class="d-flex justify-content-end mt-4">
                            <button @click="evtAgregarSolictudDeReporte" type="button" class="btn btn-light responsive-width"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar solicitud de reporte</button>
                        </div>
                    </div>
                    <div v-if="solicitudDeReportes.length > 0 && !rangoDeFechas.activo" id="contenedor-solicitud-reportes">
                        <h6>Solicitud de reportes&nbsp;&nbsp;
                            <i id="accion-eliminar-solicitudes" @click="evtLimpiarSolicitudDeReportes" class="fas fa-trash"></i>
                        </h6>
                        <div id="listado-solicitudes-reportes">
                            <div class="row">
                                <div v-for="(solicitud, index) in solicitudesDeReporte" :key="index" class="pr-2 pt-2">
                                    <div class="contenedor-reporte-solicitado">
                                        <span v-tooltip:right="`${ solicitud.juzgado  } - fecha: [ ${ solicitud.fechaReporte } ]`">{{ validarNuneroDeCaracteresSolicitudes(solicitud.juzgado) }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <i :id="solicitud.indentificadorSolicitud" @click="evtRemoverSolicitudDeListado($event)" class="fas fa-times"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="advertencias-solicitudes">
                            <i>*Solo se generará reporte de las solicitudes que contengan información.</i>
                        </div>
                        <div class="d-flex justify-content-end mt-4">
                            <button @click="evtCreacionDeReporte" type="button" class="btn btn-primary responsive-width"><i class="fas fa-file"></i>&nbsp;&nbsp;Crear Reporte</button>
                        </div>
                        <!-- <div v-if="this.visualizarReporte" class="d-flex justify-content-end mt-4">
                            <button type="button" class="btn btn-primary responsive-width"><i class="fas fa-file"></i>&nbsp;&nbsp;Descargar Reporte en Excel</button>
                        </div> -->
                    </div>
                </div>
            </div>
            <div v-if="visualizarReporte" id="visualizador-reporte-direccionNotificadores" class="col-xs-8 col-sm-8 col-md-8 col-lg-8 pl-2 pr-1">
                <PDFDocument 
                  :url="visualizadorDelReporte.url" 
                  :ArchivoAConvertir="visualizadorDelReporte.archivoDeReporte"
                  :EsBase64="EsBase64"
                  :height="visualizadorDelReporte.height"
                  :key="'VDRCEAJZ' + visualizadorDelReporte.contRender" />
            </div>
        </div>
        <!-- MODAL SELECCION DE CEDULAS PARA REPORTE -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="tabla-cedulas-creacion-reporte">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Cédulas enviadas a juzgado [Fecha: {{ fechaDeEnvio }}]</h5>
                        <!-- <button id="btn-cerrar-tabla-cedulas-creacion-reporte" @click="limpiarModalSeleccionDeCedulas" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button> -->
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div id="pasos-seleccion-cedulas">
                            <h5><i class="fas fa-info-circle"></i>&nbsp;&nbsp;PASOS :</h5>
                            <h6><strong>1)</strong> Selecciona al menos una cédula de la lista.</h6>
                            <h6><strong>2)</strong> Verifica las cédulas seleccionadas antes de guardar, una vez guardadas las cedulas no se podrá modificar la solicitud del reporte.</h6>
                            <h6><strong>3)</strong> Finaliza la creación de la solicitud del reporte en el botón <strong>Guardar</strong>.</h6>
                        </div>
                        <CTablaGenericaCedulas class="table-responsive mt-4"
                            :idDelInput="cedulasParaCreacionDeReporte.TABLA.ID"
                            :encabezadosColumnas="cedulasParaCreacionDeReporte.TABLA.encabezadosColumnas"
                            :accionesEnTabla="cedulasParaCreacionDeReporte.TABLA.tablaAcciones"
                            :listaDeCedulas="cedulasParaCreacionDeReporte.TABLA.listaMemoria"
                            :ref="cedulasParaCreacionDeReporte.TABLA.REF"
                            v-on:elementosSeleccionados="evtObtenerCedulasSeleccionadas"
                            :conResponsive="true"
                            :key="'KTablaCedulasReportDIR' + cedulasParaCreacionDeReporte.TABLA.contRender"></CTablaGenericaCedulas>
                        <div id="acciones-seleccion-cedulas" class="d-flex justify-content-end mt-4">
                            <button  type="button" @click="evtGuardarSolicitud" class="btn btn-success mr-3"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            <button  type="button" @click="limpiarModalSeleccionDeCedulas" class="btn btn-danger"><i class="fas fa-times-circle"></i>&nbsp;&nbsp;Cancelar</button>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import moment from 'moment'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
import sistemas from '@/../static/js/sistemas'
import { areasAFiltrarParaDireccion } from "../../Comun/Funciones/validaciones.js"

export default {
    components: {
        C001Area: catalogos.PJ.C001Area,
        PDFDocument,
        CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    directives: {
        tooltipF
    },
    data() {
        return {
            moment: moment,
            EsBase64:{},
            areasAFiltrarParaDireccion,
            catalogoJuzgado: {
                idInput: 'CJuzgado-VRCAJ',
                parametros: {
                    Materias: [ { MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 13, Activo: true } ],
                    elementosAOmitir: [26],
                    SistemaId: 27,
                    conOrdenamientoPorSistema: true
                },
                valorDefinido: -1,
                nombreJuzgado: null,
                contRender: 1
            },
            fechaDeEnvio: moment().format('YYYY-MM-DD'),
            enumeraciones,
            solicitudDeReportes: [],
            visualizadorDelReporte: {
                url: null,
                height: '700px',
                archivoDeReporte: null,
                contRender: 0
            },
            visualizarReporte: false,
            cedulasParaCreacionDeReporte: {
                TABLA: {
                    ID: 'tabla-seleccion-cedula-rpdir',
                    REF: 'ref-tabla-seleccion-cedula-rpdir',
                    encabezadosColumnas: ['Folio', 'Juzgado','Domicilio','Persona a notificar', 'Consecutivo', 'Tipo de cédula',''],
                    tablaAcciones: { motrarAcciones: true, check: true, eliminar: false, detalles: false },
                    contRender: 0,
                    listaMemoria: []
                },
                lista: [],
                seleccionadas: [],
                solicitudReporteTmp: null
            },
            rangoDeFechas: {
                activo: false,
                inicio: moment().subtract(1, 'days').format('YYYY-MM-DD'),
                fin: moment().format('YYYY-MM-DD'),
                MENSAJE_ERROR: 'Las fechas no pueden estar vacias, tener la fecha inicial mayor a la fecha final y la fecha final menor a la fecha inicial.'
            }
        }
    },    
    created() {
        // Filtros de areas.
        let filtrosAreas = areasAFiltrarParaDireccion({ areaDireccion: this.$store.state.Login_Usuario.Area.AreaId, conDireccion: false });

        if(filtrosAreas.elementosAOmitir != undefined || filtrosAreas.elementosAOmitir != null)
            Array.prototype.push.apply(this.catalogoJuzgado.parametros.elementosAOmitir, filtrosAreas.elementosAOmitir);

        if(filtrosAreas.elementosAConservar != undefined || filtrosAreas.elementosAConservar != null)
            this.catalogoJuzgado.parametros.elementosAConservar =  filtrosAreas.elementosAConservar;   
    },
    methods: {
        iniciarProcesoCreacionReportePorRangoDeFechas: async function() {
            if(this.rangoDeFechasValidoParaReporte()) {
                this.visualizarReporte = false;
                const { inicio, fin } = this.rangoDeFechas;
                const PETTICION_API = {
                    FechaInicial: inicio,
                    FechaFinal: fin,
                    JuzgadoId: this.catalogoJuzgado.valorDefinido,
                    NombreJuzgado: this.catalogoJuzgado.nombreJuzgado
                };
                const REPORTE_SIN_ERROR = await Promise.resolve(this.obtenerReportePorRangoDeFechasBD({ peticion: PETTICION_API }));
                if(!REPORTE_SIN_ERROR) {
                    comun.mensajeDeAlerta('No se encontró información con los parámetros ingresados.');
                }
            }
            else {
                comun.mensajeDeAlerta(this.rangoDeFechas.MENSAJE_ERROR);
            }
        },
        rangoDeFechasValidoParaReporte: function() {
            let rangoValido = true;
            const { inicio, fin } = this.rangoDeFechas;
            if(this.campoRequeridoEsValido(inicio) && this.campoRequeridoEsValido(fin)) {
                if(inicio > fin || fin < inicio)
                    rangoValido = false;
            }
            else
                rangoValido = false;
            return rangoValido;
        },
        obtenerReportePorRangoDeFechasBD: async function({ peticion }) {
            let procesoSinError = false;
            try {
                const SERVIDOR = api.conexion;
                //const METODO_API_OBTENER = api.SINOJ.sistema.reportes.reporteDeDireccion.ObtenerReporteCedulasEnviadasPorRangoDeFechas;
                const METODO_API_OBTENER = "SINOJ/ReporteDeDireccion/ObtenerReporteCedulasEnviadasPorRangoDeFechasV2";
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionArchivos = true;
                //let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,true);
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticion, headerPeticion);
                const DATOS = await RESPUESTA_SOLICITUD.data;
                /*if(DATOS != null && DATOS.byteLength > 0) {
                    this.visualizadorDelReporte.archivoDeReporte = new File([DATOS], 'ReporteCedulasEnviadasAJuzgadoRangoDeFechas', { type: 'application/pdf' });
                    this.visualizadorDelReporte.contRender ++;
                    this.visualizarReporte = true;
                    procesoSinError = true;
                }*/
                //if(DATOS != null)
                //{
                    this.EsBase64 = {
                        esBase64:true,
                        archivoBase64:DATOS.ArchivoBase64
                    }
                    this.visualizadorDelReporte.contRender ++;
                    this.visualizarReporte = true;
                    procesoSinError = true;
                    //console.log("entre::", DATOS.ArchivoBase64);
                /*}
                else{
                    comun.mensajeDeAlerta('No se encontro información para generar el reporte.');
                }*/
                /*if(this.campoRequeridoEsValido(DATOS)) {
                    const REPORTE_PDF_BYTES   = DATOS[0];
                    const REPORTE_EXCEL_BYTES = DATOS[1];

                    const ARRAY_BUFFER_PDF = this.base64ToArrayBuffer({ base64: REPORTE_PDF_BYTES });
                    this.visualizadorDelReporte.archivoDeReporte = new File([ARRAY_BUFFER_PDF], 'ReporteCedulasEnviadasAJuzgadoRangoDeFechas', { type: 'application/pdf' });
                    this.visualizadorDelReporte.contRender ++;
                    this.visualizarReporte = true;
                    procesoSinError = true;

                    if(this.campoRequeridoEsValido(REPORTE_EXCEL_BYTES)) {
                        const ARRAY_BUFFER_EXCEL = this.base64ToArrayBuffer({ base64: REPORTE_EXCEL_BYTES });
                        this.descargarArchivoPorBytes({ nombreParaDescarga: 'Reporte', byte: ARRAY_BUFFER_EXCEL, tipoDeArchivo: { type: "application/vnd.ms-excel" } });
                    }
                }*/
                comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        evtObtenerCedulasSeleccionadas: function(evento) {
            const CEDULAS_TABLA = evento;
            this.cedulasParaCreacionDeReporte.seleccionadas = CEDULAS_TABLA.filter(c => c.enviar);
        },
        evtCreacionDeReporte: function() {
            let peticion = {};
            peticion.EsPrueba = false;
            peticion.SolicitudesDeReportes = JSON.stringify(this.solicitudDeReportes);
            peticion.conInformacionCompletaDeCedulas = true;
            // let peticion = new FormData();
            // peticion.append('EsPrueba',false);
            // peticion.append('SolicitudesDeReportes',JSON.stringify(this.solicitudDeReportes));
            // peticion.append('conInformacionCompletaDeCedulas',true);
            // for (var pair of peticion.entries()) {
            //         console.log(pair[0]+ ', ',pair[1]); 
            //     } 
             const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.reportes.reporteDeDireccion.ObtenerReporteDeDireccion;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionArchivos = true;
            this.visualizarReporte = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticion,headerPeticion)
                    .then(respuesta => {
                       // console.log("RESPUESTA:::..", respuesta)            
                        if (respuesta.data.SiHayError) {
                         //   console.log("error::::::",respuesta)
                            //this.visualizadorDelReporte.archivoDeReporte = respuesta.data //new File([ARCHIVO_DESCARGADO], 'ReporteCedulasEnviadasAJuzgado', { type: 'application/pdf' });
                                this.visualizadorDelReporte.contRender ++;
                                this.visualizarReporte = true;
                           // let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                           // comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {                            
                            const ARCHIVO_DESCARGADO = respuesta.data;        
                            //console.log("correctoooo:::..", respuesta.data.ArchivoBase64 )                       
                          //  if(ARCHIVO_DESCARGADO != null && ARCHIVO_DESCARGADO.byteLength > 0) {
                            this.EsBase64={
                                  esBase64:true,
                                  archivoBase64:respuesta.data.ArchivoBase64
                                  }
                               // this.visualizadorDelReporte.archivoDeReporte = respuesta.data.ArchivoBase64; //new File([ARCHIVO_DESCARGADO], 'ReporteCedulasEnviadasAJuzgado', { type: 'application/pdf' });
                                this.visualizadorDelReporte.contRender ++;
                                this.visualizarReporte = true;
                          //  }
                          //  else
                          //      comun.mensajeDeAlerta('No se encontro información con los parámetros  ingresados en las solicitudes de reporte');
                            ///////////// Para leer multiples archivos (pdf, excel)       
                            
                            /*const ARCHIVOS_DESCARGADOS = respuesta.data
                            if(this.campoRequeridoEsValido(ARCHIVOS_DESCARGADOS)) {
                                const REPORTE_PDF_BYTES   = ARCHIVOS_DESCARGADOS[0];
                                const REPORTE_EXCEL_BYTES = ARCHIVOS_DESCARGADOS[1];

                                const ARRAY_BUFFER_PDF = this.base64ToArrayBuffer({ base64: REPORTE_PDF_BYTES });
                                this.visualizadorDelReporte.archivoDeReporte = new File([ARRAY_BUFFER_PDF], 'ReporteCedulasEnviadasAJuzgado', { type: 'application/pdf' });
                                this.visualizadorDelReporte.contRender ++;
                                this.visualizarReporte = true;

                                if(this.campoRequeridoEsValido(REPORTE_EXCEL_BYTES)) {
                                    const ARRAY_BUFFER_EXCEL = this.base64ToArrayBuffer({ base64: REPORTE_EXCEL_BYTES });
                                    this.descargarArchivoPorBytes({ nombreParaDescarga: 'Reporte', byte: ARRAY_BUFFER_EXCEL, tipoDeArchivo: { type: "application/vnd.ms-excel" } });
                                }
                            }*/
                            ////////////////////
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        base64ToArrayBuffer: function({ base64 }) {
            let cadenaBinaria = window.atob(base64);
            let longitudDeCadena = cadenaBinaria.length;
            let bytes = new Uint8Array(longitudDeCadena);
            for (let i = 0; i < longitudDeCadena; i++) {
                let ascii = cadenaBinaria.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        descargarArchivoPorBytes: function({ nombreParaDescarga, byte, tipoDeArchivo }) {
            let blob = new Blob([byte], tipoDeArchivo);
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = nombreParaDescarga;
            link.click();
        },
        evtRemoverSolicitudDeListado: function(evento) {
            const IDENTIFICADOR_SOLICITUD = evento.target.getAttribute('id');
            this.solicitudDeReportes = this.solicitudDeReportes.filter(s => s.indentificadorSolicitud != IDENTIFICADOR_SOLICITUD);
        },
        validarNuneroDeCaracteresSolicitudes: function(nombreJuzgado) {
            let nombreValido = nombreJuzgado;
            const NUMERO_VALIDO_CARACTERES = 50;
            if(nombreJuzgado.length > NUMERO_VALIDO_CARACTERES) {
                nombreValido = `${ nombreJuzgado.slice(0,50) } ...`
            }
            return nombreValido;
        },
        esUnaSolicitudValida: function() { debugger
            let respuestaDeValidaciones = {};
            respuestaDeValidaciones.esValida = true;
            if(!this.campoRequeridoEsValido(this.fechaDeEnvio)) {
                respuestaDeValidaciones.esValida = false
                respuestaDeValidaciones.mensajeError = "Se detectaron campos incorrectos, <br>Debes ingresar una fecha valida.";
                return respuestaDeValidaciones;
            }

            /* if(this.fechaDeEnvio > moment().format('YYYY-MM-DD')) {
                respuestaDeValidaciones.esValida = false
                respuestaDeValidaciones.mensajeError = "Se detectaron campos incorrectos,<br>Debes ingresar una fecha menor o igual al dia de hoy.";
                return respuestaDeValidaciones;
            } */
            
            if(this.solicitudDeReportes.length > 0) {
                const ID_SOLICITUD_ENVIAR = this.catalogoJuzgado.valorDefinido + this.fechaDeEnvio;
                respuestaDeValidaciones.esValida = !this.solicitudDeReportes.some(s => s.indentificadorSolicitud == ID_SOLICITUD_ENVIAR);
                respuestaDeValidaciones.mensajeError = "Ya has agregado una solicitud de reporte con el juzgado y la fecha ingresada";
            }
            
            return respuestaDeValidaciones;
        },
        obtenerCedulasDeSolicitudDeReporte: async function({ peticion }) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.sistema.reportes.reporteDeDireccion.ObtenerCedulasDeSolicitudDeReporte;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticion, headerPeticion);
                const DATOS = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Satisfactorio, Cedulas } = DATOS;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    if(this.campoRequeridoEsValido(Cedulas) && Cedulas.length > 0) {
                        this.cedulasParaCreacionDeReporte.lista = Cedulas.map(cDB => {
                            let cedulaObj = { ...cDB };
                            if(this.campoRequeridoEsValido(cedulaObj.Expediente) && (cedulaObj.Expediente.Acuerdos != null && cedulaObj.Expediente.Acuerdos.length > 0)) {
                                cedulaObj.Expediente.Acuerdos.forEach(a => {
                                    a.Extracto = null;
                                });
                            }
                            return cedulaObj;
                        });
                        
                        await Promise.resolve(this.convertirCedulasAFormatoTabla(this.cedulasParaCreacionDeReporte.lista));
                        comun.SeEstaCargandoInformacion(false);
                        $("#tabla-cedulas-creacion-reporte").modal('show');
                    }
                    else {
                        this.cedulasParaCreacionDeReporte.lista = [];
                        this.cedulasParaCreacionDeReporte.TABLA.listaMemoria = [];
                         comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(Satisfactorio);
                    }
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        convertirCedulasAFormatoTabla: async function(cedulas) {
            this.cedulasParaCreacionDeReporte.TABLA.listaMemoria = cedulas.map(cdb => {
                let cedulaObjTabla = {};
                cedulaObjTabla.Folio = cdb.CedulaId;
                cedulaObjTabla.Juzgado = 'Sin juzgado';
                if(this.campoRequeridoEsValido(cdb.Expediente)) { 
                    cedulaObjTabla.Juzgado = (cdb.Expediente.Juzgado != null ) ? cdb.Expediente.Juzgado.Nombre : 'Sin juzgado';
                }
                cedulaObjTabla.Domicilio = 'Sin Domicilio';
                cedulaObjTabla.PersonaANotificar = 'Sin Persona a Notificar';
                if(this.campoRequeridoEsValido(cdb.PersonasANotificar)) {
                    if(cdb.PersonasANotificar[0].Domicilios != null && cdb.PersonasANotificar[0].Domicilios.length > 0) {
                        const DOMICILIO_OBJ = cdb.PersonasANotificar[0].Domicilios[0];
                        let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                        let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
                        if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                            cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
                        }
                        else {
                            /* 
                                para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                                con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                                logica.
                            */
                            let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                            let nombreFraccionamiento = fraccionamientoCompuesto[0];
                            let nombreMunicipio = fraccionamientoCompuesto[1];
                            cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
                        }
                    }
                    
                    if(this.campoRequeridoEsValido(cdb.PersonasANotificar[0].DatosGenerales)) {
                        const { Fisica, Moral } = cdb.PersonasANotificar[0].DatosGenerales;
                        if(this.campoRequeridoEsValido(Fisica))
                            cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ Fisica.ApellidoPaterno.toUpperCase().trim() }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                        else if(this.campoRequeridoEsValido(Moral))
                            cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`; 
                    }
                }
                cedulaObjTabla.Consecutivo = 'Sin consecutivo';
                if(this.campoRequeridoEsValido(cdb.Expediente)) { 
                    cedulaObjTabla.Consecutivo = cdb.Expediente.NumeroDeDocumento;
                }
                cedulaObjTabla.TipoCedula = this.campoRequeridoEsValido(cdb.TipoCedula.Nombre) ? cdb.TipoCedula.Nombre.trim() : 'Sin tipo de cedula.';
                return cedulaObjTabla;
            });
        },
        evtAgregarSolictudDeReporte: async function() {
            /* let validarSolicitud = this.esUnaSolicitudValida();
            if(validarSolicitud.esValida) {
                const OBJ_SOLICITUD_REPORTE = {
                    indentificadorSolicitud: this.catalogoJuzgado.valorDefinido + this.fechaDeEnvio,
                    id: this.catalogoJuzgado.valorDefinido,
                    juzgado: this.catalogoJuzgado.nombreJuzgado,
                    fechaReporte: this.fechaDeEnvio
                };
                this.solicitudDeReportes.push(OBJ_SOLICITUD_REPORTE);
            }
            else {
                comun.mensajeDeAlerta(validarSolicitud.mensajeError, null, null);
            } */

            const SOLICITUD_VALIDA = this.esUnaSolicitudValida();
            if(SOLICITUD_VALIDA.esValida) {
                this.solicitudReporteTmp = {
                    indentificadorSolicitud: this.catalogoJuzgado.valorDefinido + this.fechaDeEnvio,
                    id: this.catalogoJuzgado.valorDefinido,
                    juzgado: this.catalogoJuzgado.nombreJuzgado,
                    fechaReporte: this.fechaDeEnvio,
                    cedulas: []
                };
                let peticionAPI = new FormData();
                peticionAPI.append('EsPrueba',false);
                peticionAPI.append('SolicitudDeReporte',JSON.stringify(this.solicitudReporteTmp));
                peticionAPI.append('conInformacionCompletaDeCedulas',true);
                await Promise.resolve(this.obtenerCedulasDeSolicitudDeReporte({ peticion: peticionAPI }));
            }
            else {
                comun.mensajeDeAlerta(SOLICITUD_VALIDA.mensajeError, null, null);
            }
        },
        evtGuardarSolicitud: function() {
            const TIENE_CEDULAS_SELECCIONADAS = this.cedulasParaCreacionDeReporte.seleccionadas.some(c => c.enviar);
            if(TIENE_CEDULAS_SELECCIONADAS) {
                this.solicitudReporteTmp.cedulas = this.cedulasParaCreacionDeReporte.seleccionadas.map(c => {
                    let cedulaObj = this.cedulasParaCreacionDeReporte.lista.find(cdb => cdb.CedulaId == c.folio);
                    return {...cedulaObj};
                });
                this.solicitudDeReportes.push(this.solicitudReporteTmp);
                this.limpiarModalSeleccionDeCedulas();
            }
        },
        limpiarModalSeleccionDeCedulas: function() {
            this.cedulasParaCreacionDeReporte.seleccionadas = [];
            this.cedulasParaCreacionDeReporte.TABLA.contRender ++;
            this.solicitudReporteTmp = null;
            $("#tabla-cedulas-creacion-reporte").modal('hide');
        },
        evtCambioTipoArea: function(evento) {
            this.catalogoJuzgado.valorDefinido = parseInt(evento.target.value);
            this.catalogoJuzgado.nombreJuzgado = evento.target.options[evento.target.selectedIndex].text;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        evtLimpiarSolicitudDeReportes: function() {
            this.solicitudDeReportes = [];
        }
    },
    computed: {
        solicitudesDeReporte() {
            return this.solicitudDeReportes;
        }
    }
}
</script>
<style scoped>
.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show > .btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}

.btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}

#pasos-seleccion-cedulas h6 {
    font-size: 1em;
    margin-bottom: 3px;
}

#listado-solicitudes-reportes {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 10px;
    padding-top: 6px;
    background-color: #26272b;
    border: 2px solid #5c5959;
}

.responsive-width {
     font-size : 1vw;
}

#contenedor-solicitud-reportes {
    margin-top: 3vw;
}

.contenedor-reporte-solicitado {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    padding: 0.3vw;
    border-radius: 6px;
    max-width: max-content;
    
}

.contenedor-reporte-solicitado span, .contenedor-reporte-solicitado i {
    font-size : 0.7vw;
}

.contenedor-reporte-solicitado i {
    cursor: pointer;
}

#accion-eliminar-solicitudes {
    cursor: pointer;
}

#advertencias-solicitudes i {
    font-size : 0.7vw;
}

#tabla-cedulas-creacion-reporte .modal-lg {
    max-width: 70% !important;
}

#tabla-cedulas-creacion-reporte .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Reportes/ReportesDeDireccion/CReporteDeCedulasEnviadasAJuzgado.vue